import { BankAccountStatusType } from '@moovio/moov-js';
import { Button } from '@superdispatch/ui-lab';
import { ErrorMessageBox } from 'shared/errors/SuperPayBankErrors';
import { useCustomerSupport } from 'shared/helpers/CustomerSupport';
import { BankAccountVerificationStatusType } from 'shared/modules/superpay/SuperPayDTO';

interface BankValidationErrorBannerProps {
  verificationStatus?:
    | BankAccountVerificationStatusType
    | BankAccountStatusType;
}

export function BankValidationErrorBanner({
  verificationStatus,
}: BankValidationErrorBannerProps) {
  const { showLauncherMessanger } = useCustomerSupport();
  if (verificationStatus === 'locked') {
    return (
      <ErrorMessageBox
        message="Too many failed attempts of micro-deposits verification. Contact support for assistance."
        action={
          <Button
            data-intercom-target="SuperPay Bank Verification Status Failed"
            variant="neutral"
            size="small"
            onClick={() => {
              showLauncherMessanger();
            }}
          >
            Contact Support
          </Button>
        }
      />
    );
  }

  return (
    <ErrorMessageBox
      message="Bank account verification error. Contact support for assistance."
      action={
        <Button
          data-intercom-target="SuperPay Bank Verification Status Failed"
          variant="neutral"
          size="small"
          onClick={() => {
            showLauncherMessanger();
          }}
        >
          Contact Support
        </Button>
      }
    />
  );
}
